<template>
  <!-- 公文流转各个列表页下拉筛选 -->
  <div class="select-con">
    <div>
      <div class="title">
        时间范围
        <van-radio-group v-model="radio"
                         @change="radioChange"
                         class="radio-con f13">
          <van-radio name="1"
                     style="margin-right:20px;">不限</van-radio>
          <van-radio name="2">自定义</van-radio>
        </van-radio-group>
      </div>
      <div class="choose-time"
           v-show="radio === '2'">
        <div class="start"
             @click="isShowStartDate = true">
          <span>开始时间</span>
          <div class="van-hairline--surround f14">
            <em v-show="startDate === ''">请选择</em>
            <p class="top">{{startDate}}</p>
            <p class="bot">{{startHour}}</p>
          </div>
        </div>
        <div class="center">
          <van-icon name="arrow" />
        </div>
        <div class="end"
             @click="isShowEndDate = true">
          <span>结束时间</span>
          <div class="van-hairline--surround f14">
            <em v-show="endDate === ''">请选择</em>
            <p class="top">{{endDate}}</p>
            <p class="bot">{{endHour}}</p>
          </div>
        </div>
      </div>
      <div class="title"
           v-show="showSelectStatus">审批状态</div>
      <ul v-show="showSelectStatus">
        <li v-for="item in approvalValue"
            :key="item.approvalID"
            :class="{current: approvalStatus === item.approvalID}"
            @click="chooseStatus(item.approvalID)"
            class="nowrap van-hairline--surround">
          {{item.approvalName}}
        </li>
      </ul>
      <!-- 筛选按钮 -->
      <div class="two-bottom-btn">
        <div class="cancel"
             @click="resetBtn">重置</div>
        <div class="submit"
             @click="submitBtn">确定</div>
      </div>
    </div>
    <!-- 选择开始时间 -->
    <van-popup v-model="isShowStartDate"
               position="bottom"
               :style="{ height: '45%' }">
      <van-datetime-picker v-model="startCurrentDate"
                           @cancel="startCancel"
                           @confirm="startConfirm"
                           :formatter="formatter"
                           :max-date="maxDate"
                           type="datetime">
      </van-datetime-picker>
    </van-popup>
    <!-- 选择结束时间 -->
    <van-popup v-model="isShowEndDate"
               position="bottom"
               :style="{ height: '45%' }">
      <van-datetime-picker v-model="endCurrentDate"
                           @cancel="endCancel"
                           @confirm="endConfirm"
                           :formatter="formatter"
                           :max-date="maxDate"
                           type="datetime">
      </van-datetime-picker>
    </van-popup>
  </div>
</template>
<script>
export default {
  props: {
    // 是否展示审批状态选项，默认展示，公文归档list不展示此项
    showSelectStatus: {
      type: Boolean,
      default: true
    },
  },
  name: '',
  data () {
    return {
      radio: '1',//1不限 2自定义时间范围
      //date搜索
      maxDate: new Date(),//new Date(2019, 11, 20),

      isShowStartDate: false,
      startCurrentDate: new Date(),
      startDate: '',//开始时间
      startHour: '',

      isShowEndDate: false,
      endDate: '',//结束时间
      endHour: '',
      endCurrentDate: new Date(),

      //status搜索
      status: true,//是否展示审批状态选项
      approvalStatus: -1,
      approvalValue: [
        {
          'approvalID': -1,
          'approvalName': '不限'
        },
        {
          'approvalID': 0,
          'approvalName': '待审批'
        },
        {
          'approvalID': 1,
          'approvalName': '审批中'
        },
        {
          'approvalID': 2,
          'approvalName': '已通过'
        },
        {
          'approvalID': 3,
          'approvalName': '已拒绝'
        },
        {
          'approvalID': 4,
          'approvalName': '已收回'
        }
      ],
    }
  },
  created () {

  },
  methods: {
    //radio触发事件,再次点击自定义时清空上次选项
    radioChange (val) {
      console.log(val)
      if(val === '1'){
        this.startDate = '';
        this.startHour = '';
        this.endDate = '';
        this.endHour = '';
      }
    },
    //取消选择开始时间
    startCancel () {
      this.isShowStartDate = false;
    },
    //确认选择开始时间
    startConfirm (value) {
      this.startDate = value.pattern('yyyy.MM.dd');
      this.startHour = value.pattern('HH:mm');
      this.isShowStartDate = false;
    },
    //取消选择结束时间
    endCancel () {
      this.isShowEndDate = false;
    },
    //确认选择结束时间
    endConfirm (value) {
      this.endDate = value.pattern('yyyy.MM.dd');
      this.endHour = value.pattern('HH:mm');
      this.isShowEndDate = false;
    },
    //选项格式化
    formatter (type, value) {
      if (type === 'year') {
        return `${value}年`;
      } else if (type === 'month') {
        return `${value}月`
      } else if (type === 'day') {
        return `${value}日`
      } else if (type === 'hour') {
        return `${value}时`
      } else if (type === 'minute') {
        return `${value}分`
      }
      return value;
    },
    //选择审批状态
    chooseStatus (approvalId) {
      this.approvalStatus = approvalId;
    },
    //重置下拉筛选
    resetBtn () {
      //重置时间范围
      this.radio = '1';
      this.startDate = '';
      this.startHour = '';
      this.endDate = '';
      this.endHour = '';

      //重置审批状态
      this.approvalStatus = -1;
    },
    //提交下拉筛选
    submitBtn () {
      this.$emit('submitFun', {
        radio: this.radio,
        approvalStatus: this.approvalStatus,
        startTime: `${this.startDate} ${this.startHour}`,
        endTime: `${this.endDate} ${this.endHour}`
      });
    },
  },
}
</script>
<style lang="less" scoped>
.select-con {
  position: fixed;
  width: 100%;
  height: calc(100% - 190px);
  left: 0;
  top: 190px;
  z-index: 9;
  background: rgba(0, 0, 0, 0.5); //弹框展示一半时的黑色遮罩
  > div {
    width: 100%;
    height: 100%;
    padding: 0 39px 88px;
    background: #fff;
    border-top: 2px solid #dedede;
    overflow-y: auto;
    .choose-time {
      display: flex;
      .start,
      .end {
        width: 40%;
        > span {
          display: block;
          color: #666;
          font-size: 26px;
          margin-bottom: 26px;
        }
        > div {
          height: 120px;
          background: #f5faff;
          border-radius: 8px;
          padding: 20px 0 0 30px;
          p.top {
            color: #666;
            margin-bottom: 12px;
          }
          p.bot {
            color: #111;
          }
          em {
            margin-left: 50px;
            line-height: 75px;
          }
        }
      }
      .center {
        width: 20%;
        text-align: center;
        margin-top: 15%;
        color: #999;
      }
    }
    .title {
      font-size: 28px;
      line-height: 110px;
      color: #111;
      position: relative;
      .radio-con {
        display: flex;
        position: absolute;
        top: 38px;
        left: 148px;
      }
    }
    ul {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      li {
        width: 28%;
        margin-right: 8%;
        margin-bottom: 38px;
        height: 54px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(247, 247, 247, 1);
        border-radius: 8px;
        color: #333;
      }
      li.current {
        background: @blue;
        color: #fff;
      }
      li:nth-child(3n) {
        margin-right: 0;
      }
    }
    .two-bottom-btn {
      height: 88px;
      position: absolute;
      left: 0;
      bottom: 0;
      width: 100%;
      font-size: 28px;
      display: flex;
      align-items: center;
      > div {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        height: 100%;
      }
      .cancel {
        background: #e9e9e9;
        color: #111;
      }
      .submit {
        background: @blue;
        color: #fff;
      }
    }
  }
}
</style>
